document.addEventListener("DOMContentLoaded", () => {
  const $slider = $('.reseller-great-partner-grid');

  $slider.slick({
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    customPaging: function(slider, i) {
      return $('<button>');
    },
    arrows: false,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 2.8, slidesToScroll: 1, infinite: true } },
      { breakpoint: 991,  settings: { slidesToShow: 1.8,   slidesToScroll: 1 } },
      { breakpoint: 400,  settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
    ],
  });

  $('.reseller-great-partner').css('padding', '80px 0px');
  $('.reseller-great-partner').height('auto');
});
